import montageToSchema from './../transform/montageToSchema/edit'
import { isNull } from 'lodash'
import { parseField } from '@retailfe/retail-utils'
import {
    addRelation,
    addRelationFieldValue,
    addRelationFieldList,
    FormCreatValidate
} from '../fieldRelation'

export default {
    data() {
        return {
            formRules: [],
            currentStep: 1,
            isLoading: false,
            ruleItem: {
                type: '',
                title: '',
                field: '',
                value: null,
                props: {},
                control: []
            }
        }
    },
    methods: {
        goPrev() {
            this.currentStep--
        },
        /**
         * @description is step finish
         * @param {number} index
         * @returns {string} finish
         */
        isStepFinish(index) {
            return this.currentStep >= index ? 'finish' : ''
        },
        getSchemaObject(montageTemplateList, businessParams) {
            let schemaObject = {}
            montageTemplateList.map(template => {
                schemaObject[template.id] = montageToSchema(
                    template.templateFieldParamList,
                    businessParams
                )
            })
            return schemaObject
        },
        getCurrentStep(montageTemplateList, res) {
            let currentStep
            const completedTemplateIndex = montageTemplateList.findIndex(
                template => template.id === res.currentTemplateId
            )
            const currentTemplateIndex = completedTemplateIndex + 1
            currentStep = currentTemplateIndex + 1
            return currentStep
        },
        getFormData(montageTemplateList, res) {
            // 如果有保存的数据，数据需回填
            let saveForm = {},
                { info = {} } = res
            for (let key in info) {
                !isNull(info[key]) && (saveForm[key] = info[key])
            }
            // 合并表单和已保存数据
            return {
                ...parseField(
                    montageTemplateList
                        .map(template =>
                            montageToSchema(template.templateFieldParamList)
                        )
                        .flat()
                ),
                ...saveForm
            }
        },
        addRelation(res, businessParams) {
            return addRelation(res, businessParams, montageToSchema)
        },
        addRelationFieldValue(formData, currentFormFieldList) {
            return addRelationFieldValue(formData, currentFormFieldList)
        },
        addRelationFieldList(currentFormFieldList, formData) {
            return addRelationFieldList(currentFormFieldList, formData)
        },
        FormCreatValidate(formData, currentFormFieldList) {
            return FormCreatValidate(formData, currentFormFieldList)
        }
    },
    computed: {
        /**
         * @returns {number} total step
         */
        totalStep() {
            return this.montageTemplateList
                ? this.montageTemplateList.length
                : 0
        },
        /**
         * @returns {boolean} is finish
         */
        isFinish() {
            return this.currentStep > this.totalStep
        },
        hasPreviousStep() {
            return this.currentStep !== 1
        },
        /**
         * @returns {string} next btn text
         */
        nextBtnText() {
            return this.currentStep === this.totalStep ? '提交审核' : '下一步'
        },
        steps() {
            return this.montageTemplateList.map(
                template => template.templateName
            )
        }
    }
}
